export const changePostCardView = (post, currentPostClass, newPostClass) => {
  const postElements = post.querySelectorAll(`[class*="${currentPostClass}"]`);

  post.classList.replace(currentPostClass, newPostClass);

  postElements.forEach((postElement) => {
    const className = postElement.className;
    if (className.startsWith(currentPostClass)) {
      const newClassName = className.replace(currentPostClass, newPostClass);
      postElement.classList.replace(className, newClassName);
    }
  });
};

export const togglePlan = () => {
  const togglePlanBtn = document.querySelector('.membership-toggle');
  const membershipPage = document.querySelector('.membership');

  if (!togglePlanBtn) {
    return;
  }

  togglePlanBtn.addEventListener('click', () => membershipPage.classList.toggle('yearly'));
};

export const copyToClipboard = () => {
  const shareLinkBtns = document.querySelectorAll('.copyToClipboardBtn');

  const toCopy = (clickedBtn) => {
    const url = window.location.href;

    const handleCopy = (btn, success) => {
      if (success) {
        btn.classList.add('copied');
        setTimeout(() => {
          btn.classList.remove('copied');
        }, 800);
      } else {
        btn.classList.add('notCopied');
        setTimeout(() => {
          btn.classList.remove('notCopied');
        }, 800);
      }
    };

    navigator.clipboard.writeText(url).then(
      () => {
        handleCopy(clickedBtn, true);
      },
      () => {
        handleCopy(clickedBtn, false);
      }
    );
  };

  if (shareLinkBtns) {
    Array.from(shareLinkBtns).forEach((btn) => {
      btn.addEventListener('click', () => toCopy(btn));
    });
  }
};

export const addClassToElement = (element, classNames) => {
  if (element) {
    if (typeof classNames === 'string') element.classList.add(classNames);
    if (typeof classNames === 'object') element.classList.add(...classNames);
  }
};

export const removeClassFromElement = (element, classNames) => {
  if (element) {
    if (typeof classNames === 'string') element.classList.remove(classNames);
    if (typeof classNames === 'object') element.classList.remove(...classNames);
  }
};

export const showElem = (elem) => {
  elem.classList.add('open');
  elem.classList.add('open-anim');
};

export const stopElemAnim = (elem) => {
  elem.classList.remove('open');
  elem.classList.remove('close-anim');
  elem.classList.remove('open-anim');
};

export const addCloseElemAnim = (elem) => {
  elem.classList.remove('open-anim');
  elem.classList.add('close-anim');
};

export const hideElem = (elem) => {
  elem.classList.remove('open');
  elem.classList.remove('close-anim');
};

export let timeout = {
  id: null
};
